// extracted by mini-css-extract-plugin
export default {"root":"AdminNavbar_root__u4y-U","left":"AdminNavbar_left__rJ3J5","logo":"AdminNavbar_logo__N5vDw","links":"AdminNavbar_links__nEtpp"};